import { render, staticRenderFns } from "./layout-form-row.vue?vue&type=template&id=c15e4280&scoped=true"
import script from "./layout-form-row.vue?vue&type=script&lang=js"
export * from "./layout-form-row.vue?vue&type=script&lang=js"
import style0 from "./layout-form-row.vue?vue&type=style&index=0&id=c15e4280&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c15e4280",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c15e4280')) {
      api.createRecord('c15e4280', component.options)
    } else {
      api.reload('c15e4280', component.options)
    }
    module.hot.accept("./layout-form-row.vue?vue&type=template&id=c15e4280&scoped=true", function () {
      api.rerender('c15e4280', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/ui/forms/form-row/layout-form-row.vue"
export default component.exports